module.exports = function() {
  return new Worker(__webpack_public_path__ + "cab025956b67ffa2a5e5.worker.js");
};